import { createTheme, ThemeProvider } from '@mui/material/styles';
import { QueryBuilderMaterial } from '@react-querybuilder/material';
import { QueryBuilder, RuleGroupType, ActionElement, defaultOperators } from 'react-querybuilder';
import 'react-querybuilder/dist/query-builder.css';
import React from 'react';
import { TextField, Divider } from '@mui/material';
import { voTheme } from '../../../../common/constants/themeConfig';
import CustomValueEditor from './CustomValueEditor';
import { transformQuery } from 'react-querybuilder';

const operators = [
  { name: 'null', label: 'is null' },
  { name: 'not_null', label: 'is not null' },
  { name: 'in', label: 'in' },
  { name: 'not_in', label: 'not in' },
];

export const QueryEditor = (props) => {
  return (
    <div>
      <TextField
        label="Fleet query"
        disabled
        fullWidth
        style={{ marginBottom: 10 }}
        variant="standard"
      />
      <ThemeProvider theme={voTheme}>
        <QueryBuilderMaterial>
          <QueryBuilder
            fields={props.filters}
            query={props.query}
            onQueryChange={(query) => {
              props.onChange(query);
            }}
            controlElements={{
              valueEditor: CustomValueEditor,
            }}
            operators={operators}
          />
        </QueryBuilderMaterial>
      </ThemeProvider>

      <Divider style={{ marginTop: 20 }} />
    </div>
  );
};

const ruleProcessor = (r) => ({
  ...r,
  value: r.operator.toLowerCase().includes('null') && r.value == undefined ? null : r.value,
});

export const customFormatQuery = (query) => {
  return JSON.stringify(transformQuery(JSON.parse(query), { format: 'json', ruleProcessor }), [
    'combinator',
    'id',
    'rules',
    'field',
    'operator',
    'value',
  ]);
};
